import { Controller, Get } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { HealthCheck, HealthCheckResult, HealthCheckService, MemoryHealthIndicator, MongooseHealthIndicator } from '@nestjs/terminus';

import { Public } from '../../auth';

@ApiTags('Health')
@Controller()
@Public()
export class HealthController {
  constructor(
    private readonly healthCheckService: HealthCheckService,
    private readonly memoryHealthIndicator: MemoryHealthIndicator,
    private readonly mongooseHealthIndicator: MongooseHealthIndicator
  ) {}

  @Get('/health.check')
  @HealthCheck()
  public async healthCheck(): Promise<HealthCheckResult> {
    return this.healthCheckService.check([
      async () => this.memoryHealthIndicator.checkHeap('memory_heap', 3000 * 1024 * 1024),
      async () => this.memoryHealthIndicator.checkRSS('memory_rss', 3000 * 1024 * 1024),
      async () => this.mongooseHealthIndicator.pingCheck('mongoose'),
    ]);
  }
}
